(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(24136);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ fetchBoards; }
/* harmony export */ });
/* unused harmony export ViewSetBoard */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchBoards = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Data) === null || ref2 === void 0 ? void 0 : ref2.rows
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBoards(body) {
        return _ref.apply(this, arguments);
    };
}();
var ViewSetBoard = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ViewSetBoard(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 71865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LicenseAPI; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var LicenseAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].LICENSE */ .Z.LICENSE).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function LicenseAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 9491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PartnersListSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var PartnersListSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PARTNERS */ .Z.PARTNERS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PartnersListSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 90695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ subscribeInsetSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var subscribeInsetSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SUBSCRIBE */ .Z.SUBSCRIBE).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function subscribeInsetSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 45063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _ecommerce_singleProduct_SingleProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57416);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  @media (max-width: 575px) {\n    width: 50% !important;\n  }\n  @media (max-width: 349px) {\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SingleProductTap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7d0b337f-0"
})(_templateObject());
var FeaturedTab = function(param) {
    var products = param.products;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: products && (products === null || products === void 0 ? void 0 : products.map(function(product, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleProductTap, {
                className: "col-12 col-lg-1-5 col-md-4 col-sm-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ecommerce_singleProduct_SingleProduct__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    product: product
                })
            }, i);
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeaturedTab);


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    width: fit-content;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 90vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    & h5 {\n      font-size: 18px;\n      margin: 15px 0px;\n      & pre {\n        overflow: visible !important;\n        text-align: center;\n      }\n      @media (max-width: 575px) {\n        font-size: 1rem;\n      }\n    }\n    & img {\n      width: 75%;\n    }\n\n    & a {\n      margin-top: 20px;\n      width: 200px;\n    }\n\n    @media (max-width: 991px) {\n      & a {\n        width: 150px;\n      }\n    }\n    @media (max-width: 767px) {\n      & a {\n        width: 130px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-751e3b31-0"
})(_templateObject());
var InquiryCompleteModal = function(param) {
    var onClickInquiryComplete = param.onClickInquiryComplete, confirmText = param.confirmText, confirmImg = param.confirmImg;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiryComplete();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: confirmImg || "/assets/imgs/page/common/inquiry_complete_icon.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: confirmText || "\uC18C\uC911\uD55C \uC815\uBCF4 \uAC10\uC0AC\uD569\uB2C8\uB2E4!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn",
                            onClick: onClickInquiryComplete,
                            children: "\uC644\uB8CC"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquiryCompleteModal);


/***/ }),

/***/ 80391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "DK": function() { return /* binding */ SubscibeInput; },
/* harmony export */   "OP": function() { return /* binding */ TextWrapper; },
/* harmony export */   "Sl": function() { return /* binding */ SubscibeContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "wz": function() { return /* binding */ SubscibeButton; },
/* harmony export */   "yc": function() { return /* binding */ SubscibeWrapper; }
/* harmony export */ });
/* unused harmony export StyledLink */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 230px;\n  background-color: #f4f4f4;\n  overflow-x: hidden;\n  @media (max-width: 1199px) {\n    .icon {\n      right: 10%;\n    }\n  }\n  @media (max-width: 991px) {\n    padding: 42px;\n  }\n  @media (max-width: 767px) {\n    padding: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  text-align: left;\n\n  @media (max-width: 767px) {\n    text-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 34px;\n  margin-bottom: 20px;\n  min-width: 250px;\n\n  span {\n    color: #3bb77e;\n  }\n  @media (max-width: 991px) {\n    font-size: 24px;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n    margin-bottom: 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 14px;\n  gap: 30px;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n   {\n    flex: 1;\n    height: 50px;\n    border: none;\n    outline: none;\n    padding: 0 12px;\n    font-size: 16px;\n    background-color: white;\n       \n    @media (max-width: 767px) {\n    padding: 10px 12px;\n    width: 100%;\n    margin-bottom: 15px;\n  }\n       \n   @media (max-width: 575px) {\n   padding: 10px 12px;\n   width: 100%;\n   margin-bottom: 15px;\n   }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "{\n    height: 50px;\n    padding: 0 16px;\n    border: none;\n    border-radius: 10px;\n    background-color: #3bb77e;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:hover {\n      background-color: #349b6c;\n    }\n\n    @media (max-width: 767px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  color: #666;\n  margin-top: 10px;\n\n  @media (max-width: 767px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: bold;\n  text-decoration: underline;\n  color: #3bb77e;\n  margin-top: 10px;\n\n  &:hover {\n    color: #349b6c;\n  }\n\n  @media (max-width: 767px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-fb34d78a-0"
})(_templateObject());
var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-fb34d78a-1"
})(_templateObject1());
var TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb34d78a-2"
})(_templateObject2());
// h3 스타일
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-fb34d78a-3"
})(_templateObject3());
var SubscibeContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb34d78a-4"
})(_templateObject4());
var SubscibeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fb34d78a-5"
})(_templateObject5());
var SubscibeInput = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-fb34d78a-6"
})(_templateObject6());
var SubscibeButton = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-fb34d78a-7"
})(_templateObject7());
// Paragraph 스타일
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-fb34d78a-8"
})(_templateObject8());
// Link 스타일
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-fb34d78a-9"
})(_templateObject9());


/***/ }),

/***/ 75038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ useGetBestProductsList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./api/constants/http.js
var http = __webpack_require__(23359);
// EXTERNAL MODULE: ./api/constants/resources.js
var resources = __webpack_require__(41238);
;// CONCATENATED MODULE: ./api/bestProducts.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 카테고리텝 상품목록
var BestProductsListSet = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(body) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,http/* default */.Z)(resources/* default.PRODUCTS */.Z.PRODUCTS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function BestProductsListSet(body) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./hook/best-products/useBestProductsQuery.js
function useBestProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useBestProductsQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useBestProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useBestProductsQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




// 카테고리 상세내용 불러오기
var useGetBestProductsList = function(param) {
    var limit = param.limit;
    var queryKey = limit === "4" ? [
        queryKeys/* QUERY_KEYS.PRODUCTS.BESTPRODUCTS.DETAIL */.U.PRODUCTS.BESTPRODUCTS.DETAIL
    ] : [
        queryKeys/* QUERY_KEYS.PRODUCTS.BESTPRODUCTS.INDEX */.U.PRODUCTS.BESTPRODUCTS.INDEX,
        limit
    ];
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKey,
        queryFn: useBestProductsQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return BestProductsListSet({
                            modes: "BestListSet",
                            limit: limit
                        });
                    case 3:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data.Data || {});
                    case 8:
                        {
                            console.error(res === null || res === void 0 ? void 0 : res.message); // 에러 처리
                        }
                    case 9:
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0); // 네트워크 에러 등
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        })),
        staleTime: 1000 * 60 * 5,
        retry: 1
    });
};


/***/ }),

/***/ 24136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/elements/FeaturedTab.js
var FeaturedTab = __webpack_require__(45063);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./style/categoryTabeStyle.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 30px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: center; // \uCEE8\uD14C\uC774\uB108 \uC790\uCCB4\uB97C \uC911\uC559\uC73C\uB85C\n    width: 100%;\n  }\n\n  h4 {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0;\n\n    @media (max-width: 767px) {\n      margin-bottom: 30px;\n      text-align: center;\n      width: 100%;\n    }\n  }\n\n  .nav-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin: 0;\n\n    @media (max-width: 767px) {\n      width: 100%;\n      justify-content: center; // flex \uC544\uC774\uD15C\uB4E4\uC744 \uC911\uC559\uC73C\uB85C \uC815\uB82C\n      padding-bottom: 5px;\n      flex-direction: row; // \uBA85\uC2DC\uC801\uC73C\uB85C \uAC00\uB85C \uBC29\uD5A5 \uC124\uC815\n    }\n  }\n\n  .nav-item {\n    margin: 0;\n\n    @media (max-width: 767px) {\n      display: flex;\n      justify-content: center;\n    }\n  }\n\n  .nav-link {\n    padding: 8px 15px;\n    border-radius: 4px;\n    font-size: 15px;\n    color: #777;\n    background-color: #f8f8f8;\n    border: none;\n    transition: all 0.3s ease;\n    cursor: pointer;\n\n    &.active {\n      color: #fff;\n    }\n\n    &:hover:not(.active) {\n      background-color: #eee;\n    }\n\n    @media (max-width: 767px) {\n      padding: 6px 12px;\n      font-size: 14px;\n      white-space: nowrap;\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var categoryTabeStyle_TabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4fd7a8d7-0"
})(_templateObject());

;// CONCATENATED MODULE: ./components/ecommerce/categoryTab.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function CategoryTab() {
    var ref = useState(""), active = ref[0], setActive = ref[1];
    var ref1 = useState({}), catProducts = ref1[0], setCatProducts = ref1[1];
    var ref2 = useState(false), isHovering = ref2[0], setIsHovering = ref2[1];
    var productTabRef = useRef(null);
    var fetchProducts = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var body, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "Main"
                        };
                        _ctx.next = 3;
                        return fetchProductsMain(body);
                    case 3:
                        data = _ctx.sent;
                        setCatProducts(data === null || data === void 0 ? void 0 : data.data);
                        setActive(Object.keys(data === null || data === void 0 ? void 0 : data.data)[0]);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    var catType = function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(type) {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setActive(type);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function catType(type) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        fetchProducts();
    }, []);
    // 상품 탭 영역에 마우스 호버 이벤트 추가
    useEffect(function() {
        var productTabElement = productTabRef.current;
        if (!productTabElement) return;
        var handleMouseEnter = function() {
            return setIsHovering(true);
        };
        var handleMouseLeave = function() {
            return setIsHovering(false);
        };
        productTabElement.addEventListener("mouseenter", handleMouseEnter);
        productTabElement.addEventListener("mouseleave", handleMouseLeave);
        return function() {
            productTabElement.removeEventListener("mouseenter", handleMouseEnter);
            productTabElement.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []);
    useEffect(function() {
        var keys = Object.keys(catProducts);
        if (keys.length === 0) return;
        // 호버 중일 때는 자동 전환을 중지
        if (isHovering) return;
        var updateActiveCategory = function() {
            setActive(function(prev) {
                var currentIndex = keys.findIndex(function(key) {
                    return key === prev;
                });
                var nextIndex = (currentIndex + 1) % keys.length;
                return keys[nextIndex];
            });
        };
        var intervalId = setInterval(updateActiveCategory, 5000);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        catProducts,
        isHovering
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(TabContainer, {
                className: "wow animate__animated animate__fadeIn",
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        children: "\uCD94\uCC9C\uC0C1\uD488"
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "nav nav-tabs links",
                        id: "myTab",
                        role: "tablist",
                        children: catProducts && Object.keys(catProducts).length > 0 && Object.keys(catProducts).map(function(cat, i) {
                            return /*#__PURE__*/ _jsx("li", {
                                className: "nav-item",
                                role: "presentation",
                                children: /*#__PURE__*/ _jsx("a", {
                                    className: active === cat ? "nav-link active" : "nav-link",
                                    onClick: function() {
                                        return catType(cat);
                                    },
                                    children: cat
                                })
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tab-content wow fadeIn animated",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "tab-pane fade show active",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "product-grid-4 row",
                        ref: productTabRef,
                        children: /*#__PURE__*/ _jsx(Cat1Tab, {
                            products: catProducts[active]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var categoryTab = ((/* unused pure expression or super */ null && (CategoryTab)));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 91 modules
var swiper_esm = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./api/constants/http.js
var http = __webpack_require__(23359);
// EXTERNAL MODULE: ./api/constants/resources.js
var resources = __webpack_require__(41238);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(18357);
// EXTERNAL MODULE: ./store/useBannerStore.js + 1 modules
var store_useBannerStore = __webpack_require__(95435);
;// CONCATENATED MODULE: ./components/elements/Banner5.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Banner5_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Banner5_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Banner5_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Banner5_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function Banner5_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function Banner5_templateObject() {
    var data = Banner5_taggedTemplateLiteral([
        "\n  position: absolute;\n"
    ]);
    Banner5_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = Banner5_taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow: hidden;\n\n  .P {\n    width: 100%;\n  }\n\n  .M {\n    display: none;\n    width: 100%;\n  }\n\n  @media (max-width: 1399px) {\n    height: auto;\n  }\n  @media (max-width: 991px) {\n    .P {\n      display: none;\n    }\n    .M {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Banner5_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Banner5_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 55%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #fff4b7;\n  font-size: 45px;\n  font-weight: 700;\n  @media (max-width: 991px) {\n    left: 50%;\n    font-size: 45px;\n  }\n  @media (max-width: 767px) {\n    bottom: 40%;\n    left: 50%;\n    font-size: 2rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var SlideArrows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e018dcc3-0"
})(Banner5_templateObject());
var SwiperWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e018dcc3-1"
})(_templateObject1());
var SilideEl = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e018dcc3-2"
})(_templateObject2());
var Step = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e018dcc3-3"
})(_templateObject3());
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt
]);
var Banner5 = function() {
    var mainBtmM = (0,store_useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }).mainBtmM;
    var hasMainBtmM = Array.isArray(mainBtmM) && mainBtmM.length > 0;
    var ref3 = _slicedToArray((0,dist/* useInView */.YD)({
        threshold: 0
    }), 2), stepRef = ref3[0], inView = ref3[1];
    var ref1 = (0,react.useState)(""), steps = ref1[0], setSteps = ref1[1];
    var fetchSFNZ = function() {
        var _ref = Banner5_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, body, res, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        body = {
                            modes: "AllCnt"
                        };
                        _ctx.next = 4;
                        return (0,http/* default */.Z)(resources/* default.SFNZ */.Z.SFNZ).post(body);
                    case 4:
                        res = _ctx.sent;
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.Code) === "0000") {
                            setSteps(res.data.Data.count);
                        } else {
                            ;
                            console.error(res === null || res === void 0 ? void 0 : (ref2 = res.Data) === null || ref2 === void 0 ? void 0 : ref2.Msg);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchSFNZ() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchSFNZ();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: hasMainBtmM && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperWrapper, {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                autoplay: true,
                navigation: {
                    prevEl: ".custom_prev_n",
                    nextEl: ".custom_next_n"
                },
                className: "custom-class",
                slidesPerView: 1,
                spaceBetween: 0,
                children: mainBtmM.slice(0, 1).map(function(el, i) {
                    return (el === null || el === void 0 ? void 0 : el.P_FileUrl) || (el === null || el === void 0 ? void 0 : el.M_FileUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SilideEl, {
                            "data-wow-delay": ".2s",
                            ref: stepRef,
                            style: {
                                borderRadius: "0px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: el.link_url || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    target: el.new_win === "Y" ? "_blank" : "_self",
                                    rel: el.new_win === "Y" ? "noopener noreferrer" : undefined,
                                    children: [
                                        el.P_FileUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: el.P_FileUrl,
                                            alt: el.img_alt || "PC \uC774\uBBF8\uC9C0",
                                            className: "P"
                                        }),
                                        el.M_FileUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: el.M_FileUrl,
                                            alt: el.img_alt || "\uBAA8\uBC14\uC77C \uC774\uBBF8\uC9C0",
                                            className: "M"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                start: 0,
                                                end: steps,
                                                duration: 0.5,
                                                redraw: true,
                                                separator: ","
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }, i) : null;
                })
            })
        })
    });
};
/* harmony default export */ var elements_Banner5 = (Banner5);

// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/sliders/Category.js
var Category = __webpack_require__(64728);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(21669);
;// CONCATENATED MODULE: ./components/sliders/Intro1.js
function Intro1_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Intro1_templateObject() {
    var data = Intro1_taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow: visible;\n\n  .swiper-pagination-bullet {\n    width: 8px !important;\n    height: 8px !important;\n    background-color: #ccc;\n    margin: 0 4px;\n  }\n\n  .swiper-pagination-bullet-active {\n    background-color: #1db66d;\n  }\n\n  .swiper-pagination-fraction {\n    background-color: #000;\n    width: fit-content;\n    padding: 0px 10px;\n    border-radius: 20px;\n    right: 8%;\n    color: #fff;\n    position: absolute;\n    bottom: 10px;\n    left: auto;\n    font-size: calc(10px + (14 - 10) * ((100vw - 320px) / (1920 - 320)));\n    z-index: 10;\n  }\n"
    ]);
    Intro1_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Intro1_templateObject1() {
    var data = Intro1_taggedTemplateLiteral([
        "\n  width: 600px;\n  flex-shrink: 0;\n  border-radius: 14px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .slide-img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    max-height: 310px;\n  }\n\n  @media (max-width: 767px) {\n    width: 100%;\n    flex-direction: column;\n    height: auto;\n\n    .slide-img {\n      margin-top: 16px;\n      padding: 0 16px;\n    }\n  }\n"
    ]);
    Intro1_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
]);
// ✅ Swiper wrapper
var Intro1_SwiperWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d350356b-0"
})(Intro1_templateObject());
var SlideCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d350356b-1"
})(Intro1_templateObject1());
var Intro1 = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,store_useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }), bannerList = ref.bannerList, mainTop = ref.mainTop;
    var hasMainTop = Array.isArray(mainTop) && mainTop.length > 0;
    var ref1 = (0,react.useState)(false), isMobile = ref1[0], setIsMobile = ref1[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setIsMobile(window.innerWidth <= 767);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro1_SwiperWrapper, {
        children: !hasMainTop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) // 또는 빈 배너 공간, 로딩 스켈레톤 등 처리
         : isMobile ? mainTop.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                padding: "0 16px",
                maxWidth: "540px",
                margin: "0 auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: mainTop[0].link_url || "#",
                target: mainTop[0].new_win === "Y" ? "_blank" : "_self",
                rel: mainTop[0].new_win === "Y" ? "noopener noreferrer" : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    style: {
                        overflow: "hidden",
                        borderRadius: "14px",
                        cursor: "pointer"
                    },
                    children: mainTop[0].M_FileUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: mainTop[0].M_FileUrl,
                        alt: mainTop[0].img_alt || "\uBAA8\uBC14\uC77C \uC2AC\uB77C\uC774\uB4DC",
                        style: {
                            width: "100%",
                            display: "block"
                        }
                    })
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            spaceBetween: 10,
            className: "m_swiper",
            pagination: {
                type: "fraction"
            },
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            loopAdditionalSlides: 1,
            children: mainTop.filter(function(banner) {
                return banner === null || banner === void 0 ? void 0 : banner.M_FileUrl;
            }).map(function(banner, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: banner.M_FileUrl,
                            alt: banner.img_alt || "\uBAA8\uBC14\uC77C \uBC30\uB108",
                            className: "slide-img",
                            onClick: function() {
                                return router.push("".concat(banner.link_url || "#"));
                            }
                        })
                    })
                }, i);
            })
        }, "mobile") : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            slidesPerView: "auto",
            spaceBetween: 12,
            loop: true,
            centeredSlides: true,
            pagination: {
                clickable: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            className: "mySwiper",
            children: mainTop.filter(function(el) {
                return el === null || el === void 0 ? void 0 : el.P_FileUrl;
            }).map(function(el, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    style: {
                        width: "600px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: el.P_FileUrl,
                            alt: el.img_alt || "PC \uC2AC\uB77C\uC774\uB4DC",
                            className: "slide-img",
                            onClick: function() {
                                if (el.link_url) router.push(el.link_url);
                            }
                        })
                    })
                }, i);
            })
        }, "pc")
    });
};
/* harmony default export */ var sliders_Intro1 = (Intro1);

// EXTERNAL MODULE: ./node_modules/next/document.js
var next_document = __webpack_require__(56859);
;// CONCATENATED MODULE: ./components/subscribe/subscribe.js
function subscribe_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function subscribe_templateObject() {
    var data = subscribe_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 100%;\n  padding: 50px 0px;\n  background-color: rgb(246, 246, 246);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: none !important;\n"
    ]);
    subscribe_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function subscribe_templateObject1() {
    var data = subscribe_taggedTemplateLiteral([
        "\n  display: flex;\n  .slider-btn {\n    cursor: pointer;\n    background: #fff;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n    border-radius: 50%;\n    transition: all 0.2s ease-out;\n    text-align: center;\n    font-size: 24px;\n    color: #58585f;\n    :hover {\n      background-color: #3bb77e;\n      color: #fff;\n    }\n    :first-of-type {\n      margin-right: 10px;\n    }\n  }\n"
    ]);
    subscribe_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function subscribe_templateObject2() {
    var data = subscribe_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  & h6 {\n    font-size: 1.8rem !important;\n  }\n  margin-bottom: 30px;\n"
    ]);
    subscribe_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function subscribe_templateObject3() {
    var data = subscribe_taggedTemplateLiteral([
        "\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-height: 300px;\n  transition: none !important;\n  :hover {\n    & div {\n      height: 130px;\n    }\n  }\n\n  & img {\n    width: 100%;\n    max-width: 100vw;\n    margin-bottom: 10px;\n  }\n\n  & div {\n    color: #696969;\n    width: 100%;\n    height: 100px;\n    padding: 10px 15px;\n    font-size: 14px;\n    word-break: break-all;\n    transition: height 0.3s ease;\n    background-color: #fff;\n    position: absolute;\n    bottom: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: pre-wrap;\n    display: -webkit-box;\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    word-wrap: break-word;\n  }\n"
    ]);
    subscribe_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var Instagram = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-bd69b69c-0"
})(subscribe_templateObject());
var subscribe_SlideArrows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd69b69c-1"
})(subscribe_templateObject1());
var FooterTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd69b69c-2"
})(subscribe_templateObject2());
var SNSboard = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-bd69b69c-3"
})(subscribe_templateObject3());
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt
]);
var Subscibe = function() {
    var mainBtmS = useBannerStore(function(s) {
        return s;
    }).mainBtmS;
    var hasMainBtms = Array.isArray(mainBtmS) && mainBtmS.length > 0;
    return /*#__PURE__*/ _jsxs(Instagram, {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ _jsxs(FooterTitle, {
                className: "container",
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        children: "\uC778\uAE30\uCEE8\uD150\uCE20"
                    }),
                    /*#__PURE__*/ _jsxs(subscribe_SlideArrows, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "slider-btn custom_prev_i1",
                                children: /*#__PURE__*/ _jsx("i", {
                                    className: "fi-rs-arrow-small-left"
                                })
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "slider-btn custom_next_i1",
                                children: /*#__PURE__*/ _jsx("i", {
                                    className: "fi-rs-arrow-small-right"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "container",
                children: /*#__PURE__*/ _jsx(Swiper, {
                    navigation: {
                        prevEl: ".custom_prev_i1",
                        nextEl: ".custom_next_i1"
                    },
                    className: "custom-class overflow-hidden",
                    slidesPerView: 1,
                    spaceBetween: 10,
                    breakpoints: {
                        575: {
                            slidesPerView: 1
                        },
                        767: {
                            slidesPerView: 2
                        },
                        991: {
                            slidesPerView: 3
                        },
                        1200: {
                            slidesPerView: 4
                        }
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "",
                        children: hasMainBtms && mainBtmS.map(function(el, i) {
                            return /*#__PURE__*/ _jsx(SwiperSlide, {
                                children: /*#__PURE__*/ _jsxs(SNSboard, {
                                    href: el.link_url,
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ _jsx("img", {
                                            src: el.P_FileUrl,
                                            alt: el.img_alt
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            children: el.img_alt
                                        })
                                    ]
                                })
                            }, i);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var subscribe = ((/* unused pure expression or super */ null && (Subscibe)));

// EXTERNAL MODULE: ./api/subscribe.js
var api_subscribe = __webpack_require__(90695);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./components/newsletter/newsletter.styles.js
var newsletter_styles = __webpack_require__(80391);
;// CONCATENATED MODULE: ./components/newsletter/newsletter.js
function newsletter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function newsletter_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                newsletter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                newsletter_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var Newsletter = function() {
    var ref3 = (0,react.useState)(""), email = ref3[0], setEmail = ref3[1];
    var ref1 = (0,react.useState)(false), openInquiryComplete = ref1[0], setOpenInquiryComplete = ref1[1];
    var onChangeEmail = function(e) {
        setEmail(e.target.value);
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    var subscribe = function() {
        var _ref = newsletter_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(email == "")) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        body = {
                            modes: "InsertSet",
                            email: email
                        };
                        _ctx.next = 6;
                        return (0,api_subscribe/* subscribeInsetSet */.Y)(body);
                    case 6:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            onClickInquiryComplete();
                            (0,common_alert/* successAlert */.Cq)((res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uAD6C\uB3C5 \uC2E0\uCCAD\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            setEmail("");
                        } else {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref2 = res.Data) === null || ref2 === void 0 ? void 0 : ref2.Msg) || "\uAD6C\uB3C5 \uC2E0\uCCAD\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function subscribe() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_styles/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsletter_styles/* Section */.$0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_styles/* TextWrapper */.OP, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsletter_styles/* Heading */.X6, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4"
                                    }),
                                    "\uC640 \uD568\uAED8\uD558\uB294 \uC18C\uC2DD\uC744 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "\uB193\uCE58\uC9C0 \uB9C8\uC138\uC694"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsletter_styles/* SubscibeContainer */.Sl, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsletter_styles/* SubscibeWrapper */.yc, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_styles/* SubscibeInput */.DK, {
                                            onChange: onChangeEmail,
                                            type: "text",
                                            placeholder: "\uC774\uBA54\uC77C \uC785\uB825",
                                            value: email || ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_styles/* SubscibeButton */.wz, {
                                            onClick: subscribe,
                                            children: "\uC18C\uC2DD \uBC1B\uC544\uBCF4\uAE30"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_styles/* Paragraph */.nv, {
                                    className: "font-sm",
                                    children: "\uC18C\uC2DD \uC804\uB2EC\uC744 \uBAA9\uC801\uC73C\uB85C \uC774\uB984, \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC218\uC9D1\uD558\uBA70, \uC218\uC2E0\uAC70\uBD80\uC2DC\uAE4C\uC9C0 \uC774\uC6A9 \uBC0F \uBCF4\uC720\uD569\uB2C8\uB2E4."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/esg-guide/letter/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-sm",
                                        style: {
                                            fontWeight: "bold",
                                            textDecoration: "underline",
                                            color: "#3BB77E",
                                            cursor: "pointer"
                                        },
                                        children: "\uC9C0\uB09C \uB274\uC2A4\uB808\uD130 \uBCF4\uAE30"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                onClickInquiryComplete: onClickInquiryComplete
            })
        ]
    });
};
/* harmony default export */ var newsletter = (Newsletter);

;// CONCATENATED MODULE: ./api/popups.js
function popups_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function popups_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                popups_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                popups_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 팝업 api
var PopupsListSet = function() {
    var _ref = popups_asyncToGenerator(runtime_default().mark(function _callee() {
        var body, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    body = {
                        modes: "ListSet"
                    };
                    _ctx.next = 3;
                    return (0,http/* default */.Z)(resources/* default.POPUPS */.Z.POPUPS).post(body);
                case 3:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 8:
                    return _ctx.abrupt("return", res);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PopupsListSet() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
// EXTERNAL MODULE: ./common/util/getDate.js
var getDate = __webpack_require__(69644);
;// CONCATENATED MODULE: ./components/popup/popup.styles.js
function popup_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function popup_styles_templateObject() {
    var data = popup_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 260px;\n  left: 10vw;\n  width: fit-content;\n  display: flex;\n\n  @media screen and (max-width: 1199px) {\n    left: 5vw;\n  }\n"
    ]);
    popup_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function popup_styles_templateObject1() {
    var data = popup_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n\n  @media screen and (max-width: 1199px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n    display: flex;\n  }\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n"
    ]);
    popup_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function popup_styles_templateObject2() {
    var data = popup_styles_taggedTemplateLiteral([
        "\n  z-index: 100000009;\n  width: 500px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  border: ",
        ";\n  overflow: hidden;\n  @media screen and (max-width: 767px) {\n    position: absolute;\n  }\n  @media screen and (max-width: 575px) {\n    width: 300px;\n    position: absolute;\n  }\n"
    ]);
    popup_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function popup_styles_templateObject3() {
    var data = popup_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    popup_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = popup_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  .m_image {\n    display: none;\n  }\n\n  @media screen and (max-width: 575px) {\n    .pc_image {\n      display: none;\n    }\n    .m_image {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = popup_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  border-top: 1px solid #ececec;\n  background-color: white;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = popup_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  width: 50%;\n  padding: 10px 0;\n  border-right: 1px solid #ececec;\n  cursor: pointer;\n  :hover {\n    background-color: #ececec;\n  }\n  :last-of-type {\n    border: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e827f64f-0"
})(popup_styles_templateObject());
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e827f64f-1"
})(popup_styles_templateObject1());
var PopupBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e827f64f-2"
})(popup_styles_templateObject2(), function(props) {
    return props.content ? "1px solid #ececec" : "0px";
});
var BoxHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e827f64f-3"
})(popup_styles_templateObject3());
var BoxBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e827f64f-4"
})(_templateObject4());
var BoxFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e827f64f-5"
})(_templateObject5());
var FooterBtn = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e827f64f-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./components/popup/popup.js
function popup_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return popup_arrayLikeToArray(arr);
}
function popup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function popup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                popup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                popup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || popup_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function popup_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return popup_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return popup_arrayLikeToArray(o, minLen);
}








var Popup = function() {
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)([]), popupList = ref2[0], setPopupList = ref2[1];
    var fetchPopups = function() {
        var _ref = popup_asyncToGenerator(runtime_default().mark(function _callee() {
            var res, ref, filtered, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return PopupsListSet();
                    case 2:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            ;
                            filtered = res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.rows.filter(function(el) {
                                return !(0,auth/* getCookie */.ej)("IgP".concat(el.id));
                            });
                            setPopupList(filtered);
                        } else {
                            ;
                            console.error(res === null || res === void 0 ? void 0 : (ref1 = res.Data) === null || ref1 === void 0 ? void 0 : ref1.Msg);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchPopups() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickClose = function(id) {
        popupList.splice(popupList.findIndex(function(el) {
            return el.id === id;
        }), 1, "");
        setPopupList(_toConsumableArray(popupList));
    };
    var onClickTodayClose = function(id) {
        var date = (0,getDate/* getNextDate */.OO)();
        (0,auth/* setCookie */.d8)("IgP".concat(id), date, {
            expires: date
        });
        onClickClose(id);
    };
    var openLink = function(url, option) {
        if (url) {
            option === "Y" ? window.open(url) : router.push(url);
        }
    };
    (0,react.useEffect)(function() {
        fetchPopups();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: popupList && popupList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                children: popupList.map(function(content, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupBox, {
                        content: content,
                        children: [
                            content && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxBody, {
                                onClick: function() {
                                    return openLink(content.link_url, content.new_win);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: content.P_FileUrl,
                                        className: "pc_image",
                                        alt: content.img_alt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: content.M_FileUrl,
                                        className: "m_image",
                                        alt: content.img_alt
                                    })
                                ]
                            }),
                            content && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxFooter, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBtn, {
                                        onClick: function() {
                                            return onClickTodayClose(content.id);
                                        },
                                        children: "\uC624\uB298 \uD558\uB8E8 \uC548\uBCF4\uAE30"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBtn, {
                                        onClick: function() {
                                            return onClickClose(content.id);
                                        },
                                        children: "\uB2EB\uAE30"
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            })
        })
    });
};
/* harmony default export */ var popup = (Popup);

;// CONCATENATED MODULE: ./components/layout/home_m_banner/HomeMBanner.styles.js
function HomeMBanner_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HomeMBanner_styles_templateObject() {
    var data = HomeMBanner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  width: 100%;\n\n  @media screen and (max-width: 991px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .swiper-button-prev {\n    color: #3bb77e;\n    left: 0px;\n    ::after {\n      font-size: 30px;\n    }\n  }\n\n  .swiper-button-next {\n    color: #3bb77e;\n    right: 0px;\n    ::after {\n      font-size: 30px;\n    }\n  }\n\n  .swiper-pagination-fraction {\n    background-color: #000;\n    width: fit-content;\n    padding: 0px 10px;\n    border-radius: 20px;\n    left: auto;\n    right: 15px;\n    color: #fff;\n    font-size: calc(10px + (14 - 10) * ((100vw - 320px) / (1920 - 320)));\n  }\n"
    ]);
    HomeMBanner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeMBanner_styles_templateObject1() {
    var data = HomeMBanner_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  width: 100%;\n\n  .pc_swiper {\n    display: block;\n  }\n\n  .m_swiper {\n    display: none;\n    overflow: visible;\n    margin: 0 auto;\n    position: relative;\n  }\n\n  figure {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n  }\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n\n  @media screen and (max-width: 767px) {\n    padding: 0px;\n\n    .pc_swiper {\n      display: none;\n    }\n\n    .m_swiper {\n      display: block;\n    }\n  }\n\n  &.pc-only {\n    display: block;\n\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n"
    ]);
    HomeMBanner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeMBanner_styles_templateObject2() {
    var data = HomeMBanner_styles_taggedTemplateLiteral([
        "\n  font-weight: bold;\n  line-height: 1.4;\n  background-color: ",
        ";\n"
    ]);
    HomeMBanner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeMBanner_styles_templateObject3() {
    var data = HomeMBanner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 16px;\n  margin-bottom: 60px;\n\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 30px;\n  }\n"
    ]);
    HomeMBanner_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomeMBanner_styles_templateObject4() {
    var data = HomeMBanner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  width: 70%;\n\n  h4 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n  }\n\n  @media screen and (max-width: 991px) and (min-width: 768px) {\n    width: 100%;\n  }\n\n  @media screen and (max-width: 767px) {\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n  }\n"
    ]);
    HomeMBanner_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HomeMBanner_styles_templateObject5() {
    var data = HomeMBanner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  gap: 8px;\n  margin-top: 10px;\n\n  > a {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n\n    img {\n      width: 100%;\n      max-width: 100%;\n      height: auto;\n      display: block;\n      margin: 0 auto;\n    }\n\n    span {\n      display: block;\n      font-size: 16px;\n      margin-top: 4px;\n      color: #333;\n    }\n  }\n"
    ]);
    HomeMBanner_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var BannerGridWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1f1f046e-0"
})(HomeMBanner_styles_templateObject());
var BannerSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-1f1f046e-1"
})(HomeMBanner_styles_templateObject1());
var TitleWrapper = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-1f1f046e-2"
})(HomeMBanner_styles_templateObject2(), function(param) {
    var index = param.index;
    return index === 0 ? "#d8f5d1" : index === 1 ? "#cceeff" : "#fff8cc";
});
var BannerBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1f1f046e-3"
})(HomeMBanner_styles_templateObject3());
var BannerHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1f1f046e-4"
})(HomeMBanner_styles_templateObject4());
var CertificationImageRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1f1f046e-5"
})(HomeMBanner_styles_templateObject5());

;// CONCATENATED MODULE: ./components/layout/home_m_banner/Home_m_banner.js
function Home_m_banner_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Home_m_banner_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Home_m_banner_arrayLikeToArray(arr);
}
function Home_m_banner_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Home_m_banner_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Home_m_banner_toConsumableArray(arr) {
    return Home_m_banner_arrayWithoutHoles(arr) || Home_m_banner_iterableToArray(arr) || Home_m_banner_unsupportedIterableToArray(arr) || Home_m_banner_nonIterableSpread();
}
function Home_m_banner_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Home_m_banner_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Home_m_banner_arrayLikeToArray(o, minLen);
}







swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Pagination */.tl
]);
var HomeMobileBanner = function() {
    var ref7, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var ref6 = (0,store_useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }), bannerList = ref6.bannerList, mobileBtm = ref6.mobileBtm, mainBtmFirstRowLeft = ref6.mainBtmFirstRowLeft, mainBtmFirstRowCenter = ref6.mainBtmFirstRowCenter, mainBtmFirstRowRight = ref6.mainBtmFirstRowRight, mainBtmSecondRowLeft = ref6.mainBtmSecondRowLeft, mainBtmSecondRowCenter = ref6.mainBtmSecondRowCenter, mainBtmSecondRowRight = ref6.mainBtmSecondRowRight, mainBtmThirdRowLeft = ref6.mainBtmThirdRowLeft, mainBtmThirdRowCenter = ref6.mainBtmThirdRowCenter, mainBtmThirdRowRight = ref6.mainBtmThirdRowRight, mainBtmWideSmall = ref6.mainBtmWideSmall;
    var mobileSwiperRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var ref;
        if (bannerList && (mobileBtm === null || mobileBtm === void 0 ? void 0 : mobileBtm.length) > 1 && ((ref = mobileSwiperRef.current) === null || ref === void 0 ? void 0 : ref.autoplay)) {
            mobileSwiperRef.current.autoplay.start();
            mobileSwiperRef.current.autoplay.run();
            mobileSwiperRef.current.update();
        }
    }, [
        bannerList,
        mobileBtm
    ]);
    var banners1 = [
        {
            title: "\uC778\uC99D\uBC1B\uC740 \uC0C1\uD488",
            subTitle: "\uACE8\uB77C\uBCF4\uAE30",
            data: Home_m_banner_toConsumableArray(mainBtmFirstRowLeft || []).concat(Home_m_banner_toConsumableArray(mainBtmFirstRowCenter || []), Home_m_banner_toConsumableArray(mainBtmFirstRowRight || []))
        },
        {
            title: "\uC2A4\uD398\uC15C \uC11C\uBE44\uC2A4",
            subTitle: "\uC0B4\uD3B4\uBCF4\uAE30",
            data: Home_m_banner_toConsumableArray(mainBtmSecondRowLeft || []).concat(Home_m_banner_toConsumableArray(mainBtmSecondRowCenter || []), Home_m_banner_toConsumableArray(mainBtmSecondRowRight || []))
        },
        {
            data: Home_m_banner_toConsumableArray(mainBtmThirdRowLeft || []).concat(Home_m_banner_toConsumableArray(mainBtmThirdRowCenter || []), Home_m_banner_toConsumableArray(mainBtmThirdRowRight || []))
        }, 
    ];
    var getMobileBanners = function(row) {
        var allBanners = [];
        if (row === "second") {
            var _allBanners, _allBanners1, _allBanners2, _allBanners3, _allBanners4, _allBanners5;
            if (mainBtmSecondRowLeft === null || mainBtmSecondRowLeft === void 0 ? void 0 : mainBtmSecondRowLeft.length) (_allBanners = allBanners).push.apply(_allBanners, Home_m_banner_toConsumableArray(mainBtmSecondRowLeft));
            if (mainBtmSecondRowCenter === null || mainBtmSecondRowCenter === void 0 ? void 0 : mainBtmSecondRowCenter.length) (_allBanners1 = allBanners).push.apply(_allBanners1, Home_m_banner_toConsumableArray(mainBtmSecondRowCenter));
            if (mainBtmSecondRowRight === null || mainBtmSecondRowRight === void 0 ? void 0 : mainBtmSecondRowRight.length) (_allBanners2 = allBanners).push.apply(_allBanners2, Home_m_banner_toConsumableArray(mainBtmSecondRowRight));
            if (mainBtmThirdRowLeft === null || mainBtmThirdRowLeft === void 0 ? void 0 : mainBtmThirdRowLeft.length) (_allBanners3 = allBanners).push.apply(_allBanners3, Home_m_banner_toConsumableArray(mainBtmThirdRowLeft));
            if (mainBtmThirdRowCenter === null || mainBtmThirdRowCenter === void 0 ? void 0 : mainBtmThirdRowCenter.length) (_allBanners4 = allBanners).push.apply(_allBanners4, Home_m_banner_toConsumableArray(mainBtmThirdRowCenter));
            if (mainBtmThirdRowRight === null || mainBtmThirdRowRight === void 0 ? void 0 : mainBtmThirdRowRight.length) (_allBanners5 = allBanners).push.apply(_allBanners5, Home_m_banner_toConsumableArray(mainBtmThirdRowRight));
        }
        return allBanners;
    };
    var mobileBtmSecondBanners = getMobileBanners("second");
    var renderSwiper = function(banners) {
        if (!banners.length) return null;
        return banners.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: banners[0].link_url,
            target: banners[0].new_win === "Y" ? "_blank" : "_self",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                children: Array.isArray(banners) && banners[0] && (banners[0].M_FileUrl || banners[0].P_FileUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: banners[0].M_FileUrl || banners[0].P_FileUrl,
                        alt: banners[0].img_alt || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                    })
                }) : null
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            observer: true,
            observeParents: true,
            spaceBetween: 10,
            pagination: {
                type: "fraction"
            },
            loop: true,
            loopAdditionalSlides: 1,
            onSwiper: function(swiper) {
                mobileSwiperRef.current = swiper;
            },
            children: banners.map(function(banner, i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: banner.link_url,
                        target: banner.new_win === "Y" ? "_blank" : "_self",
                        rel: "noopener noreferrer",
                        children: ((banner === null || banner === void 0 ? void 0 : banner.M_FileUrl) || (banner === null || banner === void 0 ? void 0 : banner.P_FileUrl)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: banner.M_FileUrl || banner.P_FileUrl,
                                alt: banner.img_alt || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                            })
                        })
                    })
                }, i);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerGridWrapper, {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pc_swiper",
                    children: [
                        banners1.map(function(section, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                                                index: index,
                                                children: section.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: section.subTitle
                                            })
                                        ]
                                    }),
                                    section.data.map(function(banner, i) {
                                        var linkUrl = banner === null || banner === void 0 ? void 0 : banner.link_url;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                            onClick: function() {
                                                if (linkUrl) {
                                                    router.push(linkUrl);
                                                }
                                            },
                                            style: {
                                                cursor: linkUrl ? "pointer" : "default"
                                            },
                                            children: ((banner === null || banner === void 0 ? void 0 : banner.P_FileUrl) || (banner === null || banner === void 0 ? void 0 : banner.M_FileUrl)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: banner.P_FileUrl || banner.M_FileUrl,
                                                alt: banner.img_alt || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                                            })
                                        }, i);
                                    })
                                ]
                            }, index);
                        }),
                        (mainBtmWideSmall === null || mainBtmWideSmall === void 0 ? void 0 : mainBtmWideSmall.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBox, {
                            children: mainBtmWideSmall.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                observer: true,
                                observeParents: true,
                                spaceBetween: 10,
                                pagination: {
                                    type: "fraction"
                                },
                                loop: true,
                                loopAdditionalSlides: 1,
                                children: mainBtmWideSmall.map(function(banner, i) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: banner.link_url,
                                            target: banner.new_win === "Y" ? "_blank" : "_self",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                children: ((banner === null || banner === void 0 ? void 0 : banner.P_FileUrl) || (banner === null || banner === void 0 ? void 0 : banner.M_FileUrl)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: banner.P_FileUrl || banner.M_FileUrl,
                                                    alt: banner.img_alt || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                                                })
                                            })
                                        })
                                    }, i);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: mainBtmWideSmall[0].link_url,
                                target: mainBtmWideSmall[0].new_win === "Y" ? "_blank" : "_self",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: mainBtmWideSmall[0].P_FileUrl || mainBtmWideSmall[0].M_FileUrl,
                                        alt: mainBtmWideSmall[0].img_alt
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "m_swiper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                                            index: 0,
                                            children: "\uC778\uC99D\uBC1B\uC740 \uC0C1\uD488"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: "\uACE8\uB77C\uBCF4\uAE30"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CertificationImageRow, {
                                    children: [
                                        (mainBtmFirstRowLeft === null || mainBtmFirstRowLeft === void 0 ? void 0 : mainBtmFirstRowLeft[0]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: mainBtmFirstRowLeft[0].link_url,
                                            "aria-label": mainBtmFirstRowLeft[0].img_alt || "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C",
                                            children: [
                                                (mainBtmFirstRowLeft === null || mainBtmFirstRowLeft === void 0 ? void 0 : (ref7 = mainBtmFirstRowLeft[0]) === null || ref7 === void 0 ? void 0 : ref7.M_FileUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: mainBtmFirstRowLeft[0].M_FileUrl,
                                                    alt: ((ref1 = mainBtmFirstRowLeft[0]) === null || ref1 === void 0 ? void 0 : ref1.img_alt) || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C"
                                                })
                                            ]
                                        }),
                                        (mainBtmFirstRowCenter === null || mainBtmFirstRowCenter === void 0 ? void 0 : mainBtmFirstRowCenter[0]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: mainBtmFirstRowCenter[0].link_url,
                                            "aria-label": mainBtmFirstRowCenter[0].img_alt || "\uCE5C\uD658\uACBD\uC778\uC99D",
                                            children: [
                                                (mainBtmFirstRowCenter === null || mainBtmFirstRowCenter === void 0 ? void 0 : (ref2 = mainBtmFirstRowCenter[0]) === null || ref2 === void 0 ? void 0 : ref2.M_FileUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: mainBtmFirstRowCenter[0].M_FileUrl,
                                                    alt: ((ref3 = mainBtmFirstRowCenter[0]) === null || ref3 === void 0 ? void 0 : ref3.img_alt) || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "\uCE5C\uD658\uACBD \uC778\uC99D"
                                                })
                                            ]
                                        }),
                                        (mainBtmFirstRowRight === null || mainBtmFirstRowRight === void 0 ? void 0 : mainBtmFirstRowRight[0]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: mainBtmFirstRowRight[0].link_url,
                                            "aria-label": mainBtmFirstRowRight[0].img_alt || "FSC\uC778\uC99D",
                                            children: [
                                                (mainBtmFirstRowRight === null || mainBtmFirstRowRight === void 0 ? void 0 : (ref4 = mainBtmFirstRowRight[0]) === null || ref4 === void 0 ? void 0 : ref4.M_FileUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: mainBtmFirstRowRight[0].M_FileUrl,
                                                    alt: ((ref5 = mainBtmFirstRowRight[0]) === null || ref5 === void 0 ? void 0 : ref5.img_alt) || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "FSC \uC778\uC99D"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                                            index: 1,
                                            children: "\uC2A4\uD398\uC15C \uC11C\uBE44\uC2A4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: "\uC0B4\uD3B4\uBCF4\uAE30"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        width: "100%"
                                    },
                                    children: renderSwiper(mobileBtmSecondBanners)
                                })
                            ]
                        }),
                        (mainBtmWideSmall === null || mainBtmWideSmall === void 0 ? void 0 : mainBtmWideSmall.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%"
                                },
                                children: mainBtmWideSmall.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    observer: true,
                                    observeParents: true,
                                    spaceBetween: 10,
                                    pagination: {
                                        type: "fraction"
                                    },
                                    loop: true,
                                    loopAdditionalSlides: 1,
                                    children: mainBtmWideSmall.map(function(banner, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: banner.link_url,
                                                target: banner.new_win === "Y" ? "_blank" : "_self",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: banner.M_FileUrl || banner.P_FileUrl,
                                                        alt: banner.img_alt
                                                    })
                                                })
                                            })
                                        }, i);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: mainBtmWideSmall[0].link_url,
                                    target: mainBtmWideSmall[0].new_win === "Y" ? "_blank" : "_self",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: mainBtmWideSmall[0].M_FileUrl || mainBtmWideSmall[0].P_FileUrl,
                                            alt: mainBtmWideSmall[0].img_alt
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Home_m_banner = (HomeMobileBanner);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
;// CONCATENATED MODULE: ./components/sliders/patent/patent.styles.js
function patent_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function patent_styles_templateObject() {
    var data = patent_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    patent_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function patent_styles_templateObject1() {
    var data = patent_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  & li {\n    font-size: 0.8rem !important;\n    cursor: pointer;\n  }\n  margin-bottom: 30px;\n"
    ]);
    patent_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function patent_styles_templateObject2() {
    var data = patent_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  & h6 {\n    font-size: 1.8rem !important;\n  }\n  margin-bottom: 30px;\n"
    ]);
    patent_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function patent_styles_templateObject3() {
    var data = patent_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  .slider-btn {\n    cursor: pointer;\n    background: #f6f6f6;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n    border-radius: 50%;\n    transition: all 0.2s ease-out;\n    text-align: center;\n    font-size: 24px;\n    color: #58585f;\n    :hover {\n      background-color: #3bb77e;\n      color: #fff;\n    }\n  }\n"
    ]);
    patent_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function patent_styles_templateObject4() {
    var data = patent_styles_taggedTemplateLiteral([
        "\n  & span {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    word-break: keep-all;\n  }\n  & img {\n    margin-bottom: 10px;\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);\n  }\n"
    ]);
    patent_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var PatentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e85fabe7-0"
})(patent_styles_templateObject());
var HeaderTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e85fabe7-1"
})(patent_styles_templateObject1());
var patent_styles_FooterTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e85fabe7-2"
})(patent_styles_templateObject2());
var patent_styles_SlideArrows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e85fabe7-3"
})(patent_styles_templateObject3());
var SliderBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e85fabe7-4"
})(patent_styles_templateObject4());

// EXTERNAL MODULE: ./api/license.js
var license = __webpack_require__(71865);
;// CONCATENATED MODULE: ./components/sliders/patent/patent.js
function patent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function patent_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                patent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                patent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Pagination */.tl
]);
var PatentSlider = function() {
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)([]), licenseList = ref3[0], setLicenseList = ref3[1];
    var openImg = function(img) {
        window.open(img);
    };
    var fetchLicenseList = function() {
        var _ref = patent_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref1, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,license/* LicenseAPI */.L)(body);
                    case 3:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            ;
                            setLicenseList(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : (ref1 = ref.Data) === null || ref1 === void 0 ? void 0 : ref1.rows);
                        } else {
                            ;
                            console.error(((ref2 = res.Data) === null || ref2 === void 0 ? void 0 : ref2.Msg) || "\uB9AC\uC2A4\uD2B8 \uBD88\uB7EC\uC624\uAE30 \uC5D0\uB7EC");
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchLicenseList() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchLicenseList();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PatentWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(patent_styles_FooterTitle, {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "\uD2B9\uD5C8 \uBC0F \uC778\uC99D"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(patent_styles_SlideArrows, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "hover-up",
                                onClick: function() {
                                    return router.push("/about?scrollTo=technology");
                                },
                                style: {
                                    cursor: "pointer"
                                },
                                children: "\uC804\uCCB4\uBCF4\uAE30"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        id: "patentSlider",
                        autoplay: true,
                        loop: true,
                        spaceBetween: 20,
                        navigation: {
                            prevEl: ".custom_prev_p1",
                            nextEl: ".custom_next_p1"
                        },
                        className: "custom-class",
                        slidesPerView: 2,
                        breakpoints: {
                            768: {
                                slidesPerView: 3
                            },
                            992: {
                                slidesPerView: 4
                            },
                            1200: {
                                slidesPerView: 5
                            },
                            1440: {
                                slidesPerView: 6
                            }
                        },
                        initialSlide: 0,
                        children: licenseList.map(function(el, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderBox, {
                                    onClick: function() {
                                        return openImg(el.url);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: el.url,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: el.name
                                        })
                                    ]
                                })
                            }, i);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var patent = (PatentSlider);

;// CONCATENATED MODULE: ./components/layout/home_top_banner/HomeTopBanner.styles.js
function HomeTopBanner_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HomeTopBanner_styles_templateObject() {
    var data = HomeTopBanner_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 25px;\n  height: 100%;\n  @media screen and (max-width: 991px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .swiper-button-prev {\n    color: #3bb77e;\n    left: 0px;\n    ::after {\n      font-size: 30px;\n    }\n  }\n  .swiper-button-next {\n    color: #3bb77e;\n    right: 0px;\n    ::after {\n      font-size: 30px;\n    }\n  }\n  .swiper-pagination-fraction {\n    background-color: #000;\n    width: fit-content;\n    padding: 0px 10px;\n    border-radius: 20px;\n    left: auto;\n    right: 15px;\n    color: #fff;\n    font-size: calc(10px + (14 - 10) * ((100vw - 320px) / (1920 - 320)));\n  }\n"
    ]);
    HomeTopBanner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeTopBanner_styles_templateObject1() {
    var data = HomeTopBanner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  background: #fef8e2;\n  border: 1px solid #fef8e2;\n  border-radius: 10px;\n  padding: 10px;\n  overflow: hidden;\n  height: 100%;\n\n  & ul {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    overflow: hidden;\n    height: 100%;\n  }\n  & li {\n    & a {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      color: #253d4e;\n    }\n    & span {\n      white-space: nowrap;\n    }\n    .title {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      -webkit-line-clamp: 1;\n    }\n    :hover {\n      & a,\n      span {\n        color: #3bb77e;\n      }\n    }\n  }\n  @media screen and (max-width: 1199px) {\n    max-height: 161.34px;\n    & li {\n      overflow: hidden;\n    }\n  }\n  @media screen and (max-width: 991px) {\n    display: none;\n  }\n  @media screen and (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    HomeTopBanner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeTopBanner_styles_templateObject2() {
    var data = HomeTopBanner_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n\n  .pc_swiper {\n    display: block;\n  }\n  .m_swiper {\n    display: none;\n    overflow: visible;\n    margin: 0 auto;\n    position: relative;\n  }\n\n  &.pc-only {\n    display: block;\n\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    padding: 0px;\n    .pc_swiper {\n      display: none;\n    }\n    .m_swiper {\n      display: block;\n    }\n  }\n"
    ]);
    HomeTopBanner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var HomeTopBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30d12b86-0"
})(HomeTopBanner_styles_templateObject());
var HomeTopNoticeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30d12b86-1"
})(HomeTopBanner_styles_templateObject1());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-30d12b86-2"
})(HomeTopBanner_styles_templateObject2());

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./api/boards.js
var boards = __webpack_require__(67623);
;// CONCATENATED MODULE: ./components/layout/home_top_banner/HomeTopBanner.js
function HomeTopBanner_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function HomeTopBanner_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return HomeTopBanner_arrayLikeToArray(arr);
}
function HomeTopBanner_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function HomeTopBanner_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                HomeTopBanner_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                HomeTopBanner_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function HomeTopBanner_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function HomeTopBanner_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function HomeTopBanner_toConsumableArray(arr) {
    return HomeTopBanner_arrayWithoutHoles(arr) || HomeTopBanner_iterableToArray(arr) || HomeTopBanner_unsupportedIterableToArray(arr) || HomeTopBanner_nonIterableSpread();
}
function HomeTopBanner_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return HomeTopBanner_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return HomeTopBanner_arrayLikeToArray(o, minLen);
}











swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var HomeTopBanner = function() {
    var ref8, ref1;
    var ref2 = useBannerStore(function(s) {
        return s;
    }), bannerList = ref2.bannerList, mainTopEvent = ref2.mainTopEvent, mainTopCenterEvent = ref2.mainTopCenterEvent;
    var ref3 = useState([]), noticeList = ref3[0], setNoticeList = ref3[1];
    var ref4 = useState(false), fetchLoading = ref4[0], setFetchLoading = ref4[1];
    var ref5 = useState(true), bannersLoading = ref5[0], setBannersLoading = ref5[1];
    var ref6 = useState([]), shuffledBanners = ref6[0], setShuffledBanners = ref6[1];
    var fetchNoticeList = function() {
        var _ref = HomeTopBanner_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var ref, ref7, body, res;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setFetchLoading(true);
                        body = {
                            modes: "List",
                            boardName: "notice"
                        };
                        _ctx.next = 5;
                        return fetchBoards(body);
                    case 5:
                        res = _ctx.sent;
                        if (res.code === "0000" && (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref7 = ref.data) === null || ref7 === void 0 ? void 0 : ref7.length) > 0) {
                            setNoticeList(HomeTopBanner_toConsumableArray(res.data.data.slice(0, 5)));
                        }
                        setFetchLoading(false);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchNoticeList() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        fetchNoticeList();
    }, []);
    useEffect(function() {
        if (bannerList && (mainTopEvent === null || mainTopEvent === void 0 ? void 0 : mainTopEvent.length) > 0 && mainTopCenterEvent && shuffledBanners.length === 0) {
            setShuffledBanners(shuffleArray(HomeTopBanner_toConsumableArray(mainTopEvent).concat(HomeTopBanner_toConsumableArray(mainTopCenterEvent))));
            setBannersLoading(false);
        }
    }, [
        bannerList
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(T.HomeTopBannerWrapper, {
            className: "container",
            children: [
                /*#__PURE__*/ _jsxs(T.Section, {
                    children: [
                        bannerList && (mainTopEvent === null || mainTopEvent === void 0 ? void 0 : mainTopEvent.length) > 0 && (mainTopEvent.length === 1 ? // 이미지가 1개인 경우 그냥 이미지만 표시
                        /*#__PURE__*/ _jsx("a", {
                            href: mainTopEvent[0].link_url,
                            target: mainTopEvent[0].new_win === "Y" ? "_blank" : "_self",
                            children: (mainTopEvent === null || mainTopEvent === void 0 ? void 0 : (ref8 = mainTopEvent[0]) === null || ref8 === void 0 ? void 0 : ref8.P_FileUrl) && /*#__PURE__*/ _jsx("figure", {
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: mainTopEvent[0].P_FileUrl,
                                    width: 362,
                                    height: 198,
                                    sizes: "100vw",
                                    priority: true,
                                    alt: mainTopEvent[0].img_alt || "\uBA54\uC778 \uC774\uBCA4\uD2B8 \uC774\uBBF8\uC9C0"
                                })
                            })
                        }) : // 2개 이상인 경우 Swiper 사용
                        /*#__PURE__*/ _jsx(Swiper, {
                            freeMode: true,
                            slidesPerView: 1,
                            observer: true,
                            observeParents: true,
                            spaceBetween: 25,
                            watchSlidesProgress: true,
                            className: "pc_swiper",
                            navigation: true,
                            pagination: {
                                type: "fraction"
                            },
                            loop: true,
                            loopAdditionalSlides: 1,
                            children: mainTopEvent.map(function(banner, i) {
                                /*#__PURE__*/ return _jsx(SwiperSlide, {
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: banner.link_url,
                                        target: banner.new_win === "Y" ? "_blank" : "_self",
                                        children: /*#__PURE__*/ _jsx("figure", {
                                            children: (banner === null || banner === void 0 ? void 0 : banner.P_FileUrl) && /*#__PURE__*/ _jsx(Image, {
                                                src: banner.P_FileUrl,
                                                width: 362,
                                                height: 198,
                                                sizes: "100vw",
                                                priority: true,
                                                alt: banner.img_alt || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                                            })
                                        })
                                    })
                                }, i);
                            })
                        })),
                        bannersLoading ? /*#__PURE__*/ _jsx("div", {
                            className: "d-flex justify-content-center align-items-center",
                            children: /*#__PURE__*/ _jsx(Spinner, {})
                        }) : (shuffledBanners === null || shuffledBanners === void 0 ? void 0 : shuffledBanners.length) > 0 && (shuffledBanners.length === 1 ? // 이미지가 1개인 경우 그냥 이미지만 표시
                        /*#__PURE__*/ _jsx("a", {
                            href: shuffledBanners[0].link_url,
                            target: shuffledBanners[0].new_win === "Y" ? "_blank" : "_self",
                            children: /*#__PURE__*/ _jsx("figure", {
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: shuffledBanners[0].M_FileUrl,
                                    width: 326,
                                    height: 105,
                                    sizes: "100vw",
                                    priority: true,
                                    alt: shuffledBanners[0].img_alt
                                })
                            })
                        }) : // 2개 이상인 경우 Swiper 사용
                        /*#__PURE__*/ _jsx(Swiper, {
                            observer: true,
                            observeParents: true,
                            spaceBetween: 10,
                            className: "m_swiper",
                            pagination: {
                                type: "fraction"
                            },
                            loop: true,
                            loopAdditionalSlides: 1,
                            children: shuffledBanners.map(function(banner, i) {
                                return /*#__PURE__*/ _jsx(SwiperSlide, {
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: banner.link_url,
                                        target: banner.new_win === "Y" ? "_blank" : "_self",
                                        children: /*#__PURE__*/ _jsx("figure", {
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: banner.M_FileUrl,
                                                alt: banner.img_alt
                                            })
                                        })
                                    })
                                }, i);
                            })
                        }))
                    ]
                }),
                /*#__PURE__*/ _jsx(T.Section, {
                    className: "pc-only",
                    children: bannerList && (mainTopCenterEvent === null || mainTopCenterEvent === void 0 ? void 0 : mainTopCenterEvent.length) > 0 && (mainTopCenterEvent.length === 1 ? // 이미지가 1개인 경우 그냥 이미지만 표시
                    /*#__PURE__*/ _jsx("a", {
                        href: mainTopCenterEvent[0].link_url,
                        target: mainTopCenterEvent[0].new_win === "Y" ? "_blank" : "_self",
                        children: /*#__PURE__*/ _jsx("figure", {
                            children: (mainTopCenterEvent === null || mainTopCenterEvent === void 0 ? void 0 : (ref1 = mainTopCenterEvent[0]) === null || ref1 === void 0 ? void 0 : ref1.P_FileUrl) && /*#__PURE__*/ _jsx(Image, {
                                src: mainTopCenterEvent[0].P_FileUrl,
                                width: 362,
                                height: 198,
                                sizes: "100vw",
                                priority: true,
                                alt: mainTopCenterEvent[0].img_alt || "\uC13C\uD130 \uC774\uBCA4\uD2B8 \uBC30\uB108"
                            })
                        })
                    }) : // 2개 이상인 경우 Swiper 사용
                    /*#__PURE__*/ _jsx(Swiper, {
                        freeMode: true,
                        slidesPerView: 1,
                        observer: true,
                        observeParents: true,
                        spaceBetween: 25,
                        watchSlidesProgress: true,
                        className: "pc_swiper",
                        navigation: true,
                        pagination: {
                            type: "fraction"
                        },
                        loop: true,
                        loopAdditionalSlides: 1,
                        children: mainTopCenterEvent.map(function(banner, i) {
                            /*#__PURE__*/ return _jsx(SwiperSlide, {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: banner.link_url,
                                    target: banner.new_win === "Y" ? "_blank" : "_self",
                                    children: /*#__PURE__*/ _jsx("figure", {
                                        children: (banner === null || banner === void 0 ? void 0 : banner.P_FileUrl) && /*#__PURE__*/ _jsx(Image, {
                                            src: banner.P_FileUrl,
                                            width: 362,
                                            height: 198,
                                            sizes: "100vw",
                                            priority: true,
                                            alt: banner.img_alt || "\uBC30\uB108 \uC774\uBBF8\uC9C0"
                                        })
                                    })
                                })
                            }, i);
                        })
                    }))
                }),
                /*#__PURE__*/ _jsxs(T.HomeTopNoticeWrapper, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center justify-content-between mb-2",
                            children: [
                                /*#__PURE__*/ _jsx("h6", {
                                    children: "Notice"
                                }),
                                /*#__PURE__*/ _jsx("a", {
                                    href: "/csboard/notice/",
                                    children: "more"
                                })
                            ]
                        }),
                        fetchLoading ? /*#__PURE__*/ _jsx("div", {
                            className: "h-100 d-flex align-items-center justify-content-center",
                            children: /*#__PURE__*/ _jsx(Spinner, {})
                        }) : /*#__PURE__*/ _jsx("ul", {
                            children: (noticeList === null || noticeList === void 0 ? void 0 : noticeList.length) > 0 && noticeList.map(function(v, i) {
                                return /*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        href: "/csboard/notice/".concat(v.id, "/"),
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "title",
                                                children: v.title
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "date",
                                                children: v.wdate
                                            })
                                        ]
                                    })
                                }, i);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var home_top_banner_HomeTopBanner = ((/* unused pure expression or super */ null && (HomeTopBanner)));

// EXTERNAL MODULE: ./api/partners.js
var api_partners = __webpack_require__(9491);
;// CONCATENATED MODULE: ./components/client-company/client.styles.js
function client_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function client_styles_templateObject() {
    var data = client_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  //padding: 60px 0px;\n\n  .subtitle {\n    text-align: center;\n    color: #666;\n    margin-bottom: 50px;\n  }\n"
    ]);
    client_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function client_styles_templateObject1() {
    var data = client_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 20px;\n"
    ]);
    client_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function client_styles_templateObject2() {
    var data = client_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  position: relative;\n\n  .swiper-button-next,\n  .swiper-button-prev {\n    color: #333;\n    background: rgba(255, 255, 255, 0.7);\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n\n    &:after {\n      font-size: 18px;\n    }\n  }\n\n  .swiper-pagination-bullet {\n    width: 10px;\n    height: 10px;\n    margin: 0 5px;\n  }\n\n  .swiper-pagination-bullet-active {\n    background: #0066cc;\n  }\n\n  &:hover {\n    .swiper-button-next,\n    .swiper-button-prev {\n      opacity: 1;\n    }\n  }\n"
    ]);
    client_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function client_styles_templateObject3() {
    var data = client_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n\n  @media (max-width: 992px) {\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: repeat(4, 1fr);\n  }\n\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    gap: 10px; /* \uBAA8\uBC14\uC77C\uC5D0\uC11C\uB294 \uAC04\uACA9 \uC57D\uAC04 \uC904\uC784 */\n  }\n"
    ]);
    client_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function client_styles_templateObject4() {
    var data = client_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    client_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function client_styles_templateObject5() {
    var data = client_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 140px; /* \uB192\uC774 \uC99D\uAC00 (\uAE30\uC874 100px) */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  transition: all 0.3s ease;\n  border-radius: 8px; /* \uC57D\uAC04\uC758 \uB465\uADFC \uBAA8\uC11C\uB9AC \uCD94\uAC00 */\n\n  &:hover {\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); /* \uADF8\uB9BC\uC790 \uD6A8\uACFC \uC99D\uAC00 */\n    transform: translateY(-5px); /* \uD638\uBC84 \uC2DC \uB354 \uB9CE\uC774 \uC704\uB85C \uC774\uB3D9 */\n  }\n\n  img.partner-logo {\n    max-width: 100%;\n    max-height: 110px; /* \uC774\uBBF8\uC9C0 \uCD5C\uB300 \uB192\uC774 \uC99D\uAC00 (\uAE30\uC874 70px) */\n    object-fit: contain;\n  }\n"
    ]);
    client_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function client_styles_templateObject6() {
    var data = client_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n\n  p {\n    color: #888;\n  }\n"
    ]);
    client_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var client_styles_PatentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c56aa32b-0"
})(client_styles_templateObject());
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c56aa32b-1"
})(client_styles_templateObject1());
var SwiperSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c56aa32b-2"
})(client_styles_templateObject2());
var PartnersGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c56aa32b-3"
})(client_styles_templateObject3());
var PartnerItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c56aa32b-4"
})(client_styles_templateObject4());
var ImgBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c56aa32b-5"
})(client_styles_templateObject5());
var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c56aa32b-6"
})(client_styles_templateObject6());

;// CONCATENATED MODULE: ./components/client-company/ClientCompany.js
function ClientCompany_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ClientCompany_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ClientCompany_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ClientCompany_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






// import { Navigation, Pagination, Autoplay } from "swiper";


swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var ClientCompany = function() {
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)([]), paginatedPartners = ref3[0], setPaginatedPartners = ref3[1];
    var ref1 = (0,react.useState)( true ? window.innerWidth : 0), windowWidth = ref1[0], setWindowWidth = ref1[1];
    // 화면 크기에 따라 itemsPerPage 결정
    var getItemsPerPage = (0,react.useCallback)(function() {
        if (windowWidth <= 768) {
            return 6; // 모바일 (768px 이하): 6개
        } else if (windowWidth <= 992) {
            return 12; // 태블릿 (992px 이하): 12개
        } else {
            return 12; // 데스크톱: 12개
        }
    }, [
        windowWidth
    ]);
    // 파트너 리스트를 itemsPerPage 크기로 그룹화
    var paginatePartners = (0,react.useCallback)(function(partners) {
        var totalPartners = partners.length;
        var paginatedData = [];
        var itemsPerPage = getItemsPerPage();
        for(var i = 0; i < totalPartners; i += itemsPerPage){
            paginatedData.push(partners.slice(i, i + itemsPerPage));
        }
        setPaginatedPartners(paginatedData);
    }, [
        getItemsPerPage
    ]);
    var fetchPartners = function() {
        var _ref = ClientCompany_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, partners, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,api_partners/* PartnersListSet */.d)(body);
                    case 4:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            partners = ((ref = res.Data) === null || ref === void 0 ? void 0 : ref.rows) || [];
                            paginatePartners(partners);
                        } else {
                            ;
                            console.error(res === null || res === void 0 ? void 0 : (ref2 = res.Data) === null || ref2 === void 0 ? void 0 : ref2.Msg);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error("Failed to fetch partners:", _ctx.t0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function fetchPartners() {
            return _ref.apply(this, arguments);
        };
    }();
    //재조회
    (0,react.useEffect)(function() {
        fetchPartners();
    }, []);
    // 화면 크기 변경 감지
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // 화면 크기가 변경될 때 파트너 데이터 재구성
    (0,react.useEffect)(function() {
        // fetchPartners가 이미 호출된 후에만 실행
        if (paginatedPartners.length > 0) {
            // 모든 파트너를 단일 배열로 평탄화
            var allPartners = paginatedPartners.flat();
            // 새로운 화면 크기에 맞게 다시 페이지네이션
            paginatePartners(allPartners);
        }
    }, [
        windowWidth,
        paginatePartners
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(client_styles_PatentWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "\uACE0\uAC1D\uC0AC"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "hover-up",
                        onClick: function() {
                            return router.push("/partners");
                        },
                        style: {
                            cursor: "pointer"
                        },
                        children: "\uB354\uBCF4\uAE30"
                    })
                ]
            }),
            paginatedPartners.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperSection, {
                className: "position-relative overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 1,
                    autoplay: true,
                    loop: true,
                    pagination: false,
                    navigation: true,
                    initialSlide: 0,
                    children: paginatedPartners.map(function(page, pageIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersGrid, {
                                children: page.map(function(partner, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgBox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "partner-logo",
                                                src: partner.img_url,
                                                alt: partner.img_alt || "\uD30C\uD2B8\uB108\uC0AC \uB85C\uACE0 ".concat(index + 1)
                                            })
                                        })
                                    }, "".concat(pageIndex, "-").concat(index));
                                })
                            })
                        }, pageIndex);
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "\uD30C\uD2B8\uB108\uC0AC \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911\uC785\uB2C8\uB2E4..."
                })
            })
        ]
    });
};
/* harmony default export */ var client_company_ClientCompany = (ClientCompany);

// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
;// CONCATENATED MODULE: ./components/elements/BestProductTab.js
function BestProductTab_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BestProductTab_templateObject() {
    var data = BestProductTab_taggedTemplateLiteral([
        "\n  width: 25%; /* \uAE30\uBCF8\uC801\uC73C\uB85C 4\uAC1C \uC815\uB82C (25% x 4 = 100%) */\n  padding: 0 10px;\n  position: relative;\n\n  @media (max-width: 991px) {\n    width: 33.333%; /* \uD0DC\uBE14\uB9BF\uC5D0\uC11C\uB294 3\uAC1C \uC815\uB82C */\n  }\n\n  @media (max-width: 767px) {\n    width: 50%; /* \uC791\uC740 \uD0DC\uBE14\uB9BF\uACFC \uBAA8\uBC14\uC77C\uC5D0\uC11C\uB294 2\uAC1C \uC815\uB82C */\n  }\n\n  @media (max-width: 349px) {\n    width: 100%; /* \uB9E4\uC6B0 \uC791\uC740 \uD654\uBA74\uC5D0\uC11C\uB294 1\uAC1C \uC815\uB82C */\n  }\n"
    ]);
    BestProductTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BestProductTab_templateObject1() {
    var data = BestProductTab_taggedTemplateLiteral([
        '\n  position: absolute;\n  top: 0px;\n  left: 24px;\n  z-index: 49;\n  width: 52px;\n  height: 60px;\n  background-image: url("https://static-resource-smartstore.pstatic.net/smartstore/p/static/20250219164238/img/sprite/svg/spSs_theme_svg.svg");\n  background-size: 300px 222px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  /* \uC21C\uC704\uC5D0 \uB530\uB978 \uBC30\uACBD \uC704\uCE58 \uC124\uC815 */\n  &.rank-1 {\n    background-position: -64px -72px;\n  }\n\n  &.rank-2 {\n    background-position: -64px -72px;\n  }\n\n  &.rank-3 {\n    background-position: -64px -72px;\n  }\n\n  &.rank-4 {\n    background-position: -4px -72px;\n  }\n\n  /* \uC21C\uC704 \uC22B\uC790 */\n  & span.rank-number {\n    position: relative;\n    color: white;\n    font-size: 20px;\n    font-weight: bold;\n    margin-top: -10px; /* \uC704\uCE58 \uC870\uC815 */\n    z-index: 2;\n  }\n\n  /* BEST \uD14D\uC2A4\uD2B8 */\n  & span.rank-text {\n    position: relative;\n    color: white;\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n    margin-top: -5px; /* \uC704\uCE58 \uC870\uC815 */\n    z-index: 2;\n  }\n\n  /* \uBAA8\uBC14\uC77C\uC5D0\uC11C \uD06C\uAE30 \uC870\uC815 */\n  @media (max-width: 767px) {\n    width: 45px;\n    height: 60px;\n\n    & span.rank-number {\n      font-size: 18px;\n    }\n\n    & span.rank-text {\n      font-size: 9px;\n    }\n  }\n'
    ]);
    BestProductTab_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SingleProductTap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-576a39f7-0"
})(BestProductTab_templateObject());
var RankBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-576a39f7-1"
})(BestProductTab_templateObject1());
var BestProductTab = function(param) {
    var products = param.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row",
        children: products && (products === null || products === void 0 ? void 0 : products.map(function(product, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SingleProductTap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankBadge, {
                        className: "rank-".concat(i + 1),
                        rank: i + 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "rank-number",
                                children: i + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "rank-text",
                                children: "BEST"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                        product: product
                    })
                ]
            }, i);
        }))
    });
};
/* harmony default export */ var elements_BestProductTab = (BestProductTab);

;// CONCATENATED MODULE: ./components/best-product/bestproduct.styles.js
function bestproduct_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function bestproduct_styles_templateObject() {
    var data = bestproduct_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  & li {\n    font-size: 0.9rem !important;\n    cursor: pointer;\n  }\n\n  /* \uC804\uCCB4\uBCF4\uAE30 \uBC84\uD2BC */\n  & li.hover-up {\n    margin-left: auto;\n  }\n\n  @media (max-width: 767px) {\n    flex-wrap: wrap;\n    gap: 10px;\n\n    /* \uBAA8\uBC14\uC77C\uC5D0\uC11C \uC694\uC18C \uC815\uB82C */\n    & h4 {\n      width: 100%;\n      text-align: center;\n      margin-bottom: 15px;\n    }\n\n    & li.hover-up {\n      order: 3; /* \uB9C8\uC9C0\uB9C9 \uC21C\uC11C\uB85C \uC124\uC815 */\n      font-size: 0.8rem !important;\n    }\n  }\n"
    ]);
    bestproduct_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function bestproduct_styles_templateObject1() {
    var data = bestproduct_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 1; /* \uAC00\uB2A5\uD55C \uACF5\uAC04\uC744 \uCC28\uC9C0\uD558\uB3C4\uB85D \uC124\uC815 */\n  justify-content: center; /* \uC911\uC559 \uC815\uB82C */\n  flex-wrap: wrap;\n  padding-right: 7%;\n\n  @media (max-width: 767px) {\n    order: 2; /* \uC911\uAC04 \uC21C\uC11C\uB85C \uC124\uC815 */\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n    padding-right: 0;\n\n    & li {\n      margin: 3px;\n    }\n\n    & .nav-link {\n      padding: 5px 10px;\n      font-size: 0.85rem !important;\n    }\n  }\n\n  @media (max-width: 480px) {\n    & .nav-link {\n      padding: 3px 8px;\n      font-size: 0.8rem !important;\n    }\n  }\n"
    ]);
    bestproduct_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var bestproduct_styles_HeaderTitle = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-a1ec29ec-0"
})(bestproduct_styles_templateObject());
var HeaderCategory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1ec29ec-1"
})(bestproduct_styles_templateObject1());

// EXTERNAL MODULE: ./hook/best-products/useBestProductsQuery.js + 1 modules
var useBestProductsQuery = __webpack_require__(75038);
;// CONCATENATED MODULE: ./components/best-product/BestProduct.js
function BestProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BestProduct_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BestProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BestProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var categoryTranslation = {
    daily: "\uC77C\uAC04",
    weekly: "\uC8FC\uAC04",
    monthly: "\uC6D4\uAC04"
};
var BestProduct = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)("daily"), active = ref[0], setActive = ref[1];
    var ref1 = (0,react.useState)(false), isHovering = ref1[0], setIsHovering = ref1[1];
    var productTabRef = (0,react.useRef)(null);
    var ref2 = (0,useBestProductsQuery/* useGetBestProductsList */.E)({
        limit: "4"
    }), tmp = ref2.data, catProducts = tmp === void 0 ? {} : tmp, fetchIsLoading = ref2.isPending, error = ref2.error;
    // 데이터가 로드되었을 때 첫 번째 카테고리를 active로 설정
    (0,react.useEffect)(function() {
        if (catProducts && Object.keys(catProducts).length > 0 && !active) {
            setActive(Object.keys(catProducts)[0]);
        }
    }, [
        catProducts,
        active
    ]);
    var handleCategoryChange = function() {
        var _ref = BestProduct_asyncToGenerator(runtime_default().mark(function _callee(type) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setActive(type);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCategoryChange(type) {
            return _ref.apply(this, arguments);
        };
    }();
    // 제품 탭 영역에 마우스 호버 이벤트 추가
    (0,react.useEffect)(function() {
        var productTabElement = productTabRef.current;
        if (!productTabElement) return;
        var handleMouseEnter = function() {
            return setIsHovering(true);
        };
        var handleMouseLeave = function() {
            return setIsHovering(false);
        };
        productTabElement.addEventListener("mouseenter", handleMouseEnter);
        productTabElement.addEventListener("mouseleave", handleMouseLeave);
        return function() {
            productTabElement.removeEventListener("mouseenter", handleMouseEnter);
            productTabElement.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []);
    (0,react.useEffect)(function() {
        var keys = Object.keys(catProducts);
        if (keys.length === 0) return;
        // 호버 중일 때는 자동 전환을 중지
        if (isHovering) return;
        var updateActiveCategory = function() {
            setActive(function(prev) {
                var currentIndex = keys.findIndex(function(key) {
                    return key === prev;
                });
                var nextIndex = (currentIndex + 1) % keys.length;
                return keys[nextIndex];
            });
        };
        var intervalId = setInterval(updateActiveCategory, 5000);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        catProducts,
        isHovering
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "section-title style-2 wow animate__animated animate__fadeIn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(bestproduct_styles_HeaderTitle, {
                    className: "nav nav-tabs links",
                    id: "myTab",
                    role: "tablist",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "\uC2E4\uC2DC\uAC04 \uBCA0\uC2A4\uD2B8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCategory, {
                            children: Object.keys(catProducts).map(function(category, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item",
                                    role: "presentation",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: active === category ? "nav-link active" : "nav-link",
                                        onClick: function() {
                                            return handleCategoryChange(category);
                                        },
                                        role: "button",
                                        children: categoryTranslation[category] || category
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "hover-up",
                            onClick: function() {
                                return router.push("/products/best");
                            },
                            children: "\uC804\uCCB4\uBCF4\uAE30"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tab-content wow fadeIn animated",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tab-pane fade show active",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-grid-4",
                        ref: productTabRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_BestProductTab, {
                            products: catProducts[active]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var best_product_BestProduct = (BestProduct);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
;// CONCATENATED MODULE: ./hook/csboard/useNoticeListQuery.js
function useNoticeListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useNoticeListQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useNoticeListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useNoticeListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//메인에 노출되는 TOP 5 공지사항
var fetchNoticeList = function() {
    var _ref = useNoticeListQuery_asyncToGenerator(runtime_default().mark(function _callee() {
        var body, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    body = {
                        modes: "List",
                        boardName: "notice"
                    };
                    _ctx.next = 3;
                    return (0,boards/* fetchBoards */.P)(body);
                case 3:
                    res = _ctx.sent;
                    if (!(res.code === "0000")) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", res.data.data.slice(0, 5));
                case 6:
                    return _ctx.abrupt("return", []);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNoticeList() {
        return _ref.apply(this, arguments);
    };
}();
var useNoticeListQuery = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            "noticeList"
        ],
        queryFn: fetchNoticeList
    });
};

;// CONCATENATED MODULE: ./components/layout/NoticeESG.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NoticeESG_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NoticeESG_templateObject() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 40px;\n  width: 100%;\n  justify-content: space-between;\n  padding: 30px 0;\n\n  @media screen and (max-width: 991px) and (min-width: 768px) {\n    flex-direction: column;\n    gap: 50px;\n  }\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    gap: 50px;\n  }\n"
    ]);
    NoticeESG_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NoticeESG_templateObject1() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    NoticeESG_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NoticeESG_templateObject2() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  flex: 1;\n\n  .pc_esg {\n    display: block;\n\n    @media (max-width: 768px) {\n      display: none;\n    }\n  }\n\n  .m_esg {\n    display: none;\n\n    @media (max-width: 768px) {\n      display: block;\n    }\n\n    .swiper {\n      padding-bottom: 20px;\n    }\n  }\n\n  .swiper-pagination-fraction {\n    background-color: #000;\n    width: fit-content;\n    padding: 0px 10px;\n    border-radius: 20px;\n    left: auto;\n    right: 15px;\n    bottom: 65px;\n    color: #fff;\n    font-size: calc(10px + (14 - 10) * ((100vw - 320px) / (1920 - 320)));\n  }\n"
    ]);
    NoticeESG_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NoticeESG_templateObject3() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: bold;\n  font-size: 26px;\n  margin-bottom: 16px;\n\n  .more-text {\n    font-size: 14px;\n    font-weight: normal;\n    color: #888;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n  }\n"
    ]);
    NoticeESG_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NoticeESG_templateObject4() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  background-color: #9f9f9f;\n  border-radius: 999px;\n  padding: 3px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n\n  i {\n    font-size: 16px;\n    color: #fff;\n    line-height: 1;\n  }\n"
    ]);
    NoticeESG_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NoticeESG_templateObject5() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  overflow: hidden;\n"
    ]);
    NoticeESG_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NoticeESG_templateObject6() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 16px;\n  font-size: 14px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover span:first-child {\n    color: #3bb77e;\n  }\n\n  span:last-child {\n    color: #aaa;\n    font-size: 13px;\n  }\n"
    ]);
    NoticeESG_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 7%;\n\n  @media screen and (max-width: 991px) and (min-width: 768px) {\n    justify-content: center;\n  }\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = NoticeESG_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 250px;\n  height: 250px;\n\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n\n  .image-area {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  img {\n    max-width: 90%;\n    max-height: 90%;\n    object-fit: contain;\n    background: #f9f9f9;\n    border-radius: 12px;\n    cursor: pointer;\n  }\n\n  .summary-overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 14px;\n    color: #666;\n    line-height: 1.4;\n    padding: 0 20px;\n    text-align: start;\n    display: -webkit-box;\n    -webkit-line-clamp: 8;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    width: 90%;\n    pointer-events: none;\n  }\n\n  .title {\n    font-size: 16px;\n    color: #333;\n    margin-top: auto;\n    padding: 0 8px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n  }\n\n  &:hover .title {\n    color: #3bb77e;\n    cursor: pointer;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    height: auto;\n\n    .title {\n      font-size: 15px;\n      padding: 8px 0;\n    }\n\n    .summary-overlay {\n      -webkit-line-clamp: 5;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}










swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Pagination */.tl
]);
var NoticeESG = function(param) {
    var dummyList = param.dummyList;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = useNoticeListQuery(), tmp = ref1.data, noticeList = tmp === void 0 ? [] : tmp;
    var defaultImage = "/img/esg_default_img.png";
    var processed = (dummyList === null || dummyList === void 0 ? void 0 : (ref = dummyList.esg) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        var match = item.contents.match(/<img[^>]+src="([^"]+)"[^>]*>/);
        return _objectSpread({}, item, {
            imageUrl: match ? match[1] : defaultImage
        });
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoticeESGWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoticeSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "\uACF5\uC9C0\uC0AC\uD56D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "more-text hover-up",
                                onClick: function() {
                                    return router.push("/csboard/notice/");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "\uC804\uCCB4\uBCF4\uAE30"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMoreButton, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-plus-small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeList, {
                        children: noticeList.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoticeItem, {
                                onClick: function() {
                                    return router.push("/csboard/notice/".concat(item.id, "/"));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.wdate
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ESGSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "ESG\uC790\uB8CC\uC2E4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "more-text hover-up",
                                onClick: function() {
                                    return router.push("/esg-guide/news/");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "\uC804\uCCB4\uBCF4\uAE30"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMoreButton, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-plus-small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pc_esg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ESGList, {
                            children: processed.map(function(item) {
                                var isDefault = item.imageUrl === defaultImage;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ESGItem, {
                                    isDefault: isDefault,
                                    onClick: function() {
                                        return router.push("/esg-guide/post/".concat(item.id, "/"));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "image-area",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: item.imageUrl,
                                                    alt: item.title
                                                }),
                                                isDefault && item.summary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "summary-overlay",
                                                    children: item.summary
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "title",
                                            children: item.title
                                        })
                                    ]
                                }, item.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "m_esg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            spaceBetween: 10,
                            pagination: {
                                type: "fraction"
                            },
                            loop: true,
                            loopAdditionalSlides: 1,
                            children: processed.map(function(item) {
                                var isDefault = item.imageUrl === defaultImage;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ESGItem, {
                                        isDefault: isDefault,
                                        onClick: function() {
                                            return router.push("/esg-guide/post/".concat(item.id, "/"));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "image-area",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item.imageUrl,
                                                        alt: item.title
                                                    }),
                                                    isDefault && item.summary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "summary-overlay",
                                                        children: item.summary
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "title",
                                                children: item.title
                                            })
                                        ]
                                    })
                                }, item.id);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ var layout_NoticeESG = ((0,es/* connect */.$j)(mapStateToProps)(NoticeESG));
// --------------------- styled-components ---------------------
var NoticeESGWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-175a35ad-0"
})(NoticeESG_templateObject());
var NoticeSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-175a35ad-1"
})(NoticeESG_templateObject1());
var ESGSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-175a35ad-2"
})(NoticeESG_templateObject2());
var SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-175a35ad-3"
})(NoticeESG_templateObject3());
var StyledMoreButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-175a35ad-4"
})(NoticeESG_templateObject4());
var NoticeList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-175a35ad-5"
})(NoticeESG_templateObject5());
var NoticeItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-175a35ad-6"
})(NoticeESG_templateObject6());
var ESGList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-175a35ad-7"
})(_templateObject7());
var ESGItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-175a35ad-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./data/BrandLogo.js
var BrandLogo = [
    {
        //스텝포넷제로
        activeSrc: "/icons/brand/\uC2A4\uD15D\uD3EC \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uC2A4\uD15D\uD3EC \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uC2A4\uD15D\uD3EC.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%8A%A4%ED%85%9D%ED%8F%AC%EB%84%B7%EC%A0%9C%EB%A1%9C",
        pcode: "P2503281523411674,P2205311704118515,P2210190939214050,P2301171108094628,P2308221520262025"
    },
    {
        //리펄프
        activeSrc: "/icons/brand/\uB9AC\uD384\uD504 \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uB9AC\uD384\uD504 \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uB9AC\uD384\uD504.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EB%A6%AC%ED%8E%84%ED%94%84%ED%85%8C%EC%9D%B4%ED%94%84",
        pcode: "P2307261403244664,P2403211814230907,P2403211744090311,P2407171416573973,P2309151538424038"
    },
    {
        //에코날개박스
        activeSrc: "/icons/brand/\uC5D0\uCF54\uB0A0\uAC1C\uBC15\uC2A4 \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uC5D0\uCF54\uB0A0\uAC1C\uBC15\uC2A4 \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uC5D0\uCF54\uB0A0\uAC1C\uBC15\uC2A4.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%97%90%EC%BD%94%EB%82%A0%EA%B0%9C%EB%B0%95%EC%8A%A4",
        pcode: "P2103221606263171,P2405311440501766,P2405281800316659,P2503201052177017,P2104121054162729"
    },
    {
        //우림
        activeSrc: "/icons/brand/\uC6B0\uB9BC \uB85C\uACE01.png",
        inactiveSrc: "/icons/brand/\uC6B0\uB9BC \uB85C\uACE0 \uBE44\uD65C\uC1311.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uC6B0\uB9BC.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%9A%B0%EB%A6%BC",
        pcode: "P2308171343553418,P2204271140076716,P2103171930517715,P2204271106380718,P2406241714411655"
    },
    {
        //아세아상자세상
        activeSrc: "/icons/brand/\uC544\uC138\uC544\uC0C1\uC790\uC138\uC0C1 \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uC544\uC138\uC544\uC0C1\uC790\uC138\uC0C1 \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uC544\uC138\uC544\uC0C1\uC790\uC138\uC0C1.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%95%84%EC%84%B8%EC%95%84",
        pcode: "P2401191414587994,P2401191414592645,P2606261608258090,P2606291128480092,P2401191414590601"
    },
    {
        //안박스
        activeSrc: "/icons/brand/\uC548\uBC15\uC2A4 \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uC548\uBC15\uC2A4 \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uC548\uBC15\uC2A4.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%95%88%EB%B0%95%EC%8A%A4",
        pcode: "P2504291348167792,P2504291348171810,P2504291348171486,P2504291348168392,P2504291348179244"
    },
    {
        //박스다사
        activeSrc: "/icons/brand/\uBC15\uC2A4\uB2E4\uC0AC \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uBC15\uC2A4\uB2E4\uC0AC \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uBC15\uC2A4\uB2E4\uC0AC.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EB%B0%95%EC%8A%A4%EB%8B%A4%EC%82%AC",
        pcode: "P2411201507376094,P2411201555118460,P2411201504188240,P2505141443032998,P2505141443022565"
    },
    {
        //리그라운드
        activeSrc: "/icons/brand/\uB9AC\uADF8\uB77C\uC6B4\uB4DC \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uB9AC\uADF8\uB77C\uC6B4\uB4DC \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uB9AC\uADF8\uB77C\uC6B4\uB4DC.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?search=%EB%A6%AC%EA%B7%B8%EB%9D%BC%EC%9A%B4%EB%93%9C",
        pcode: "P2102261108119945,P2407171015395017,P2102261242112535,P2103011425037703,P2102261839508771"
    },
    {
        //박스마루
        activeSrc: "/icons/brand/\uBC15\uC2A4\uB9C8\uB8E8 \uB85C\uACE0.png",
        inactiveSrc: "/icons/brand/\uBC15\uC2A4\uB9C8\uB8E8 \uB85C\uACE0 \uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uBC15\uC2A4\uB9C8\uB8E8.png",
        mainBannerUrl: "https://www.caretstore.co.kr/search/?search=%EB%B0%95%EC%8A%A4%EB%A7%88%EB%A3%A8",
        pcode: "P2409251545229382,P2409251512334924,P2409251101472560,P2409241735527469,P2409191417263521"
    },
    {
        //폴팩
        activeSrc: "/icons/brand/\uC138\uBAA8\uC1FC\uD551\uBC31_\uD65C\uC131.png",
        inactiveSrc: "/icons/brand/\uC138\uBAA8\uC1FC\uD551\uBC31_\uBE44\uD65C\uC131.png",
        mainBannerImg: "/img/brand/\uC81C\uD734\uBC30\uB108_\uC138\uBAA8\uC1FC\uD551\uBC31.png",
        mainBannerUrl: "https://www.caretstore.co.kr/products/Paper-Shooping-Bag/",
        pcode: "P2509021622311824,P2509021622357516,P2509021622365189,P2509021622368413,P2509021622358679"
    }, 
];

;// CONCATENATED MODULE: ./components/brand/brand.styles.js
function brand_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function brand_styles_templateObject() {
    var data = brand_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n\n  img {\n    width: 120px;\n    height: auto;\n    transition: transform 0.2s ease;\n  }\n"
    ]);
    brand_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function brand_styles_templateObject1() {
    var data = brand_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  & h6 {\n    font-size: 1.8rem !important;\n  }\n  margin-bottom: 30px;\n"
    ]);
    brand_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function brand_styles_templateObject2() {
    var data = brand_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 24px;\n  justify-items: center;\n  align-items: center;\n  margin-top: 20px;\n\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(2, 1fr); // \uBAA8\uBC14\uC77C\uC5D0\uC11C 2\uC5F4\n    gap: 16px; // \uBAA8\uBC14\uC77C\uC5D0\uC11C \uAC04\uACA9 \uCD95\uC18C\n  }\n"
    ]);
    brand_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function brand_styles_templateObject3() {
    var data = brand_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    width: 130px;\n    height: auto;\n  }\n"
    ]);
    brand_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function brand_styles_templateObject4() {
    var data = brand_styles_taggedTemplateLiteral([
        "\n  margin-top: 40px;\n  display: flex;\n  justify-content: center;\n\n  img {\n    max-width: 1200px;\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n    transition: transform 0.2s ease;\n  }\n\n  &:hover img {\n    transform: scale(1.05);\n    cursor: pointer;\n  }\n"
    ]);
    brand_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function brand_styles_templateObject5() {
    var data = brand_styles_taggedTemplateLiteral([
        "\n  margin-top: 40px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: 1fr;\n  flex-wrap: wrap;\n  gap: 25px;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    margin-top: 20px;\n    gap: 10px;\n  }\n"
    ]);
    brand_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function brand_styles_templateObject6() {
    var data = brand_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  cursor: pointer;\n\n  img {\n    width: 100%;\n    height: auto;\n    border: 1px solid #ededed;\n    border-radius: 16px;\n    transition: transform 0.2s ease;\n  }\n\n  &:hover img {\n    transform: scale(1.05);\n  }\n"
    ]);
    brand_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var brand_styles_PatentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7368af19-0"
})(brand_styles_templateObject());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7368af19-1"
})(brand_styles_templateObject1());
var BrandGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7368af19-2"
})(brand_styles_templateObject2());
var BrandBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7368af19-3"
})(brand_styles_templateObject3());
var BannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7368af19-4"
})(brand_styles_templateObject4());
var ProductListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7368af19-5"
})(brand_styles_templateObject5());
var ProductBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7368af19-6"
})(brand_styles_templateObject6());

;// CONCATENATED MODULE: ./components/brand/MainBrand.js
function MainBrand_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function MainBrand_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                MainBrand_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                MainBrand_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var MainBrand = function(param) {
    var userDevice = param.userDevice;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), activeIdx = ref[0], setActiveIdx = ref[1];
    var ref1 = (0,react.useState)([]), productData = ref1[0], setProductData = ref1[1];
    var activeBrand = BrandLogo[activeIdx];
    (0,react.useEffect)(function() {
        if (!(activeBrand === null || activeBrand === void 0 ? void 0 : activeBrand.pcode)) return;
        var fetchData = function() {
            var _ref = MainBrand_asyncToGenerator(runtime_default().mark(function _callee() {
                var body, res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            body = {
                                modes: "MultiListSet",
                                items: activeBrand.pcode
                            };
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,products/* ProductsApi */.qO)(body);
                        case 4:
                            res = _ctx.sent;
                            setProductData(Object.values(res.Data.Data));
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error("\uC0C1\uD488 \uB370\uC774\uD130 \uAC00\uC838\uC624\uAE30 \uC2E4\uD328:", _ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        activeIdx
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(brand_styles_PatentWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
            className: "container row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: "\uC81C\uD734 \uBE0C\uB79C\uB4DC"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandGrid, {
                    children: BrandLogo.map(function(brand, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBox, {
                            onClick: function() {
                                return setActiveIdx(idx);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: activeIdx === idx ? brand.activeSrc : brand.inactiveSrc,
                                alt: "\uBE0C\uB79C\uB4DC \uB85C\uACE0 ".concat(idx)
                            })
                        }, idx);
                    })
                }),
                userDevice === "web" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: activeBrand.mainBannerImg,
                        alt: "\uBE0C\uB79C\uB4DC \uBC30\uB108",
                        onClick: function() {
                            return router.push("".concat(activeBrand.mainBannerUrl));
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper, {
                    children: productData.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.main_image,
                                alt: item.name,
                                onClick: function() {
                                    return router.push("/products/".concat(item.ename, "/").concat(item.pcode, "/"));
                                }
                            })
                        }, item.pcode);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/index.js
function pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function pages_templateObject() {
    var data = pages_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 15px;\n  margin-bottom: 30px;\n\n  @media (max-width: 767px) {\n    margin-bottom: 20px;\n  }\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pages_templateObject1() {
    var data = pages_taggedTemplateLiteral([
        "\n  margin-bottom: 70px;\n\n  @media (max-width: 767px) {\n    margin-bottom: 40px;\n  }\n"
    ]);
    pages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function pages_templateObject2() {
    var data = pages_taggedTemplateLiteral([
        "\n  margin-bottom: 35px;\n\n  @media (max-width: 767px) {\n    margin-bottom: 0px;\n  }\n"
    ]);
    pages_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function pages_templateObject3() {
    var data = pages_taggedTemplateLiteral([
        "\n  margin-top: 45px;\n  margin-bottom: 70px;\n\n  @media (max-width: 767px) {\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n"
    ]);
    pages_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function pages_templateObject4() {
    var data = pages_taggedTemplateLiteral([
        "\n  margin-top: 20px;\n  margin-bottom: 70px;\n\n  @media (max-width: 767px) {\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n"
    ]);
    pages_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function pages_templateObject5() {
    var data = pages_taggedTemplateLiteral([
        "\n  border-top: 2px solid #d9d9d9;\n  margin: 0 auto 20px auto;\n  width: 100%;\n  width: 1120px;\n\n  @media (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    pages_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


















var pages_SwiperSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-12f6684a-0"
})(pages_templateObject());
var PopularCategoriesSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-12f6684a-1"
})(pages_templateObject1());
var EventBannerSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-12f6684a-2"
})(pages_templateObject2());
var pages_NoticeSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-12f6684a-3"
})(pages_templateObject3());
var BrandSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-12f6684a-4"
})(pages_templateObject4());
var SectionDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12f6684a-5"
})(pages_templateObject5());
function Home(param) {
    var siteConfig = param.siteConfig, userDevice = param.userDevice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                noBreadcrumb: "d-none",
                siteConfig: siteConfig,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_SwiperSection, {
                        className: "position-relative overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sliders_Intro1, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularCategoriesSection, {
                        className: "popular-categories section-padding position-relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container wow animate__fadeIn animate__animated position-relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-center mb-35",
                                    children: "\uC804\uCCB4 \uC11C\uBE44\uC2A4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Category/* default */.Z, {
                                    siteConfig: siteConfig
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "product-tabs section-padding position-relative overflow-hidden mb-70 mb-lg-2",
                        style: {
                            background: "#F4F4F4"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container overflow-hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(best_product_BestProduct, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBrand, {
                            userDevice: userDevice
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventBannerSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container wow animate__fadeIn animate__animated",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_m_banner, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_NoticeSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container wow animate__fadeIn animate__animated",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_NoticeESG, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "banners mb-2 mb-lg-5",
                        style: {
                            background: "#2C332D"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Banner5, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "mt-20 mb-70",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container wow animate__fadeIn animate__animated",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_company_ClientCompany, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "mb-2 mb-lg-5 section-padding",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(patent, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "banners",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter, {})
                    })
                ]
            })
        ]
    });
}
var pages_mapStateToProps = function(state) {
    return {
        banners: state.banners
    };
};
/* harmony default export */ var pages = ((0,es/* connect */.$j)(pages_mapStateToProps, null)(Home));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4901,2511,7166,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);